export function normalizeFilterText(text = "") {
    if (!text || (typeof text !== "string")) return "";

    return text
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .replace(/\s+/g, "")
        .toLowerCase();
}